var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#EE2737"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.4788 7.88236L16.0813 5.47618C15.7684 5.1812 15.3584 5.01194 14.9292 5.00061C14.5 4.98927 14.0817 5.13665 13.7538 5.41471L5.87869 13.3182C5.59585 13.6045 5.41975 13.9797 5.37993 14.3808L5.00368 18.0428C4.99189 18.1714 5.00852 18.3011 5.05238 18.4225C5.09624 18.5439 5.16626 18.6542 5.25743 18.7453C5.33919 18.8267 5.43616 18.8911 5.54277 18.9348C5.64937 18.9785 5.76353 19.0007 5.87869 19H5.95744L9.60623 18.6663C10.0059 18.6263 10.3798 18.4496 10.665 18.1657L18.5401 10.2622C18.8457 9.93813 19.0109 9.50567 18.9994 9.05958C18.988 8.61349 18.8007 8.19017 18.4788 7.88236ZM9.44873 16.9099L6.8237 17.1558L7.05995 14.5213L12.0038 9.62114L14.3663 11.9922L9.44873 16.9099ZM15.5038 10.8154L13.1588 8.46195L14.865 6.70562L17.2538 9.10302L15.5038 10.8154Z",
  fill: "white",
  stroke: "#EE2737",
  strokeWidth: 0.8
});

var SvgVodafoneIndiaEdit = function SvgVodafoneIndiaEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVodafoneIndiaEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vodafone-india-edit.53aaa252.svg";
export { ForwardRef as ReactComponent };